<template>
  <q-menu content-class="shadow3 r-popup" :max-height="maxHeight || undefined">
    <q-list class="no-border">
      <q-item
        v-for="(item, index) of items"
        :key="item.name"
        v-close-popup="!item.disable && !dontCloseOnClick"
        :disable="item.disable"
        :class="{ 'border-top': item.borderTop, 'border-bottom': item.borderBottom, 'sticky-top': item.stickyTop }"
        class="q-pa-sm"
        clickable
        @click="$emit('popup-item', item, index)"
      >
        <LmTooltip v-if="item.hover">
          <div class="text-body-1" style="white-space: pre">
            {{ item.hover }}
          </div>
        </LmTooltip>

        <slot name="before" :item="item" :index="index"></slot>

        <q-item-section :class="getTextClasses(item)">
          {{ item.label }}
          <div v-if="item.subLabel" class="text-caption-1 text-secondary-1">{{ item.subLabel }}</div>
        </q-item-section>

        <slot name="after" :item="item" :index="index"></slot>
      </q-item>
    </q-list>
  </q-menu>
</template>

<script>
export default {
  props: {
    /*
     * Example:
     * [
     *  { name: 'edit-current-period', label: 'Edit current period', textColorClass: 'text-secondary-2', textFontClass: 'text-body-1' },
     *  { name: 'edit-current-period', label: 'Edit current period', disable: true, borderTop: true, borderBottom: true, hover: 'This gets shown on hover' }
     * ]
     *
     * All the properties that the object can contain:
     * name: String => This will be used as the name for the emitted event
     * label: String => The text to show for the item
     * subLabel: String => The text to show for the item caption
     * disable: Boolean => For disabling the item
     * borderTop: Boolean => For adding border top to the item
     * borderBottom: Boolean => For adding border bottom to the item
     * hover: String => Text to display on hover
     * textColorClass: String => color class from the style guide
     * fontColorClass: String => font class from the style guide
     * stickyTop: Boolean => if you want the item to have sticky top 0 position
     * */
    items: Array,
    dontCloseOnClick: Boolean,
    maxHeight: String
  },

  methods: {
    getTextClasses(item) {
      const classes = []

      if (item.disable) classes.push(...['text-grey2', 'text-body-1'])
      else {
        const colorClass = item.textColorClass || 'text-secondary-2'
        const fontClass = item.textFontClass || 'text-body-1'

        classes.push(...[colorClass, fontClass])
      }

      return classes
    }
  }
}
</script>

<style lang="scss" scoped>
.r-popup {
  .q-list {
    min-width: 180px;
  }

  .q-item {
    min-height: unset;

    &.border-top {
      border-top: 1px solid var(--r-white-4);
    }

    &.border-bottom {
      border-bottom: 1px solid var(--r-white-4);
    }

    &.sticky-top {
      position: sticky;
      top: 0;
      z-index: 1;
      background: var(--r-white-1);
    }

    &:hover,
    &:focus {
      background: var(--r-white-2);
    }
  }
}
</style>

<style lang="scss">
@import '~@/styles/mixins';

@include custom-scrollbar('.r-popup');
</style>
